import React, { useState } from "react";
import { string, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import TextField from "../../../atoms/TextField";
import Button from "../../../atoms/button";
import CheckBox from "../../../atoms/checkbox";

import { setLoading } from "../../../helper/actions";
import { submitNewsLetter } from "../../../helper/api";
import { readCookie } from "../../../helper/cookies";

import "./subscribePage.m.css";

const SubscribePageView = ({ publisherName, id, token, setLoading }) => {
  const initialState = {
    email: "",
    firstName: "",
    lastName: "",
    fitAgreeToTerms: true,
  };

  const [userInfo, setUserInfo] = useState(initialState);
  const [isValid, setValid] = useState(false);
  const [msg, setMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [successClass, setSuccessClass] = useState("");

  const setData = (e) => {
    const obj = { ...userInfo };

    obj[e.target.name] = e.target.value;

    setUserInfo(obj);
  };

  const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
    return re.test(email);
  };

  const onCheckboxChange = (e) => {
    const obj = { ...userInfo };

    obj.fitAgreeToTerms = e.target.checked;

    setUserInfo(obj);
  };

  const onSubmit = () => {
    if (!validateEmail(userInfo.email)) {
      setValid(true);
      return;
    }

    const thinmint = readCookie("thinmint");

    const body = {
      email_address: userInfo.email,
      status: "subscribed",
      merge_fields: {
        FNAME: userInfo.firstName,
        LNAME: userInfo.lastName,
        DEVICEID: thinmint,
      },
    };

    setLoading(true);
    submitNewsLetter(id, token, body)
      .then((text) => {
        setMsg(text);
        setUserInfo(initialState);
        window.dataLayer.push({
          event: "subscribeNewsLetter",
        });
      })
      .catch(() => {
        setMsg("Something went wrong");
        setSuccessClass("failure");
      })
      .finally(() => {
        setSuccess(true);
        setLoading(false);
      });
  };

  const handleFocus = () => setValid(false);

  return (
    <div styleName="wrapper" className="container">
      <span styleName="heading">
        {publisherName === "fit" ? "Subscribe to FIT’s daily Newsletter" : "Subscribe to our Newsletter"}
      </span>

      <div styleName="content">
        <span styleName="content-title">Is your inbox living on junk? It needs a daily dose of The Quint.</span>

        <div styleName="fields-wrapper">
          <TextField
            placeholder="Email"
            name="email"
            value={userInfo.email}
            onChange={setData}
            onFocus={handleFocus}
            error={isValid ? "Invalid Email" : ""}
          />
          <TextField placeholder="First Name" name="firstName" value={userInfo.firstName} onChange={setData} />
          <TextField placeholder="Last Name" name="lastName" value={userInfo.lastName} onChange={setData} />
          <CheckBox
            isChecked={userInfo.fitAgreeToTerms}
            type="type2"
            text="I agree to the terms of the privacy policy"
            onChange={onCheckboxChange}
          />

          {success && <span styleName={`msg ${successClass}`}>{msg}</span>}
          <Button content="Submit" buttonType="type2" onClick={onSubmit} />
        </div>

        <div styleName="widget-wrapper">
          <iframe src="https://www.thequint.com/quintlab/widgets/whatsapp-fb-subscription-widget"></iframe>
        </div>
      </div>
    </div>
  );
};

SubscribePageView.propTypes = {
  publisherName: string,
  setLoading: func,
  id: string,
  token: string,
};

const mapStateToProps = (state) => {
  const item = get(state, ["qt", "config", "publisher-attributes", "mailchimp"], {});

  return {
    publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
    id: item.listId,
    token: item.token,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

const SubscribePage = connect(mapStateToProps, mapDispatchToProps)(SubscribePageView);

export { SubscribePage };
